<!-- src/app/components/footer/footer.component.html -->
<footer>
  <div class="container">

    <!-- SKIP LINK TARGET -->
    <div class="footer-grid">

      <!-- BRAND -->
      <div class="footer-brand">
        <div class="footer-logo">
          <img src="/assets/Logo.png" alt="Lydia Christensen Logo" />
          <img class="footer-logo-lp" src="/assets/Libertarian_Disc.svg" alt="Libertarian Party Logo" />
          <div>
            <span class="footer-name">Lydia Christensen</span>
            <span class="footer-tagline">Michigan's Unchained Voice</span>
          </div>
        </div>
        <p class="footer-mission">
          Running for U.S. Senate in Michigan as the Libertarian Party nominee - putting Michigan first, not establishment politics.
        </p>
        <div class="social-links">
          <a href="https://www.facebook.com/profile.php?id=61574235554571" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
            <svg viewBox="0 0 24 24"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" /></svg>
          </a>
          <a href="https://www.tiktok.com/@lydiaforussenate" target="_blank" rel="noopener noreferrer" aria-label="TikTok">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor"><path d="M9 0h1.98c.144.715.54 1.617 1.235 2.512C12.895 3.389 13.797 4 15 4v2c-1.753 0-3.07-.814-4-1.829V11a5 5 0 1 1-5-5v2a3 3 0 1 0 3 3z"/></svg>
          </a>
          <a href="https://bsky.app/profile/lydiaforussenate.bsky.social" target="_blank" rel="noopener noreferrer" aria-label="Bluesky">
            <img src="https://upload.wikimedia.org/wikipedia/commons/7/7a/Bluesky_Logo.svg" alt="Bluesky" width="22" height="22">
          </a>
          <a href="https://discord.gg/DNqwMBsycY" target="_blank" rel="noopener noreferrer" aria-label="Discord">
            <svg viewBox="0 0 24 24"><path d="M20.317 4.37a19.791 19.791 0 0 0-4.885-1.515.074.074 0 0 0-.079.037c-.21.375-.444.864-.608 1.25a18.27 18.27 0 0 0-5.487 0 12.64 12.64 0 0 0-.617-1.25.077.077 0 0 0-.079-.037A19.736 19.736 0 0 0 3.677 4.37a.07.07 0 0 0-.032.027C.533 9.046-.32 13.58.099 18.057a.082.082 0 0 0 .031.057 19.9 19.9 0 0 0 5.993 3.03.078.078 0 0 0 .084-.028 14.09 14.09 0 0 0 1.226-1.994.076.076 0 0 0-.041-.106 13.107 13.107 0 0 1-1.872-.892.077.077 0 0 1-.008-.128 10.2 10.2 0 0 0 .372-.292.074.074 0 0 1 .077-.01c3.928 1.793 8.18 1.793 12.062 0a.074.074 0 0 1 .078.01c.12.098.246.198.373.292a.077.077 0 0 1-.006.127 12.299 12.299 0 0 1-1.873.892.077.077 0 0 0-.041.107c.36.698.772 1.362 1.225 1.993a.076.076 0 0 0 .084.028 19.839 19.839 0 0 0 6.002-3.03.077.077 0 0 0 .032-.054c.5-5.177-.838-9.674-3.549-13.66a.061.061 0 0 0-.031-.03z"/></svg>
          </a>
        </div>
      </div>

      <!-- NAV: CAMPAIGN -->
      <div class="footer-nav">
        <h4>Campaign</h4>
        <a routerLink="/">Home</a>
        <a routerLink="/about">About Lydia</a>
        <a routerLink="/issues">Issues & Platform</a>
        <a routerLink="/newsroom">Newsroom</a>
        <a routerLink="/endorsements">Endorsements</a>
        <a routerLink="/events">Events</a>
        <a routerLink="/tracker">Bill Tracker</a>
        <a routerLink="/report-card">Delegation Report Card</a>
        <a routerLink="/press">Press Kit</a>
        <a routerLink="/faq">FAQ</a>
        <a routerLink="/compare">Compare Candidates</a>
      </div>

      <!-- NAV: GET INVOLVED -->
      <div class="footer-nav">
        <h4>Get Involved</h4>
        <a routerLink="/donate">Donate</a>
        <a routerLink="/merch">Campaign Store</a>
        <a routerLink="/volunteer">Volunteer</a>
        <a routerLink="/coalitions">Join a Coalition</a>
        <a routerLink="/petitions">Sign a Petition</a>
        <a routerLink="/phone-bank">Phone Banking</a>
        <a routerLink="/contact">Contact Us</a>
        <a href="https://discord.gg/DNqwMBsycY" target="_blank" rel="noopener noreferrer">Join Discord</a>
      </div>

      <!-- NEWSLETTER -->
      <div class="footer-newsletter">
        <h4>Stay Updated</h4>
        <app-newsletter-signup></app-newsletter-signup>
      </div>

    </div>

    <!-- BOTTOM BAR -->
    <div class="footer-bottom">
      <p class="fec-disclaimer">
        Paid for by Lydia Christensen for United States Senate, Lydia Christensen, Treasurer. FEC ID: C00903575.
        Contributions are not tax-deductible. U.S. citizens and permanent residents only. $3,300/election limit.
      </p>
      <div class="footer-legal">
        <a routerLink="/privacy">Privacy Policy</a>
        <span>·</span>
        <a href="https://www.fec.gov" target="_blank" rel="noopener noreferrer">FEC.gov</a>
        <span>·</span>
        <span>&copy; 2026 Lydia Christensen for U.S. Senate</span>
      </div>
    </div>

  </div>
</footer>
